import React, { useState } from "react";
import { LibraryBooks } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { useCanViewBomComparison } from "fond/hooks/useCanViewBom";
import BomComparisonModal from "fond/project/bom/BomComparisonModal";
import { Architecture, Project } from "fond/types";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  project: Project;
  architecture: Architecture | null;
  handleClose: () => void;
}

const BomComparison: React.FC<IProps> = ({ project, architecture, handleClose }: IProps) => {
  const [bomComparisonModal, showBomComparisonModal] = useState(false);
  const canViewBomComparison = useCanViewBomComparison(project);
  const handleClick = () => {
    if (canViewBomComparison) {
      showBomComparisonModal(true);
      handleClose();
      trackPageMenuItemClick("project", "bom-comparison", project);
    }
  };

  return (
    <>
      <MenuItem data-testid="bom-comparison-button" onClick={handleClick} disabled={!canViewBomComparison}>
        <ListItemIcon>
          <LibraryBooks />
        </ListItemIcon>
        View all Bills of Materials
      </MenuItem>
      {bomComparisonModal && <BomComparisonModal project={project} architecture={architecture} onClose={() => showBomComparisonModal(false)} />}
    </>
  );
};

export default BomComparison;
